module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "fluid",
    attrs: {
      "dialog": "modal-sm",
      "footer": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n        Send message\n    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form', {
    staticClass: "wrapper fs-normal",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.send($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-row mb-3"
  }, [_c('v-select', {
    attrs: {
      "label": "name",
      "placeholder": "Select or search for an agent",
      "options": _vm.agents
    },
    model: {
      value: (_vm.message.to),
      callback: function($$v) {
        _vm.$set(_vm.message, "to", $$v)
      },
      expression: "message.to"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.text),
      expression: "message.text"
    }],
    attrs: {
      "placeholder": "Write your message here ..."
    },
    domProps: {
      "value": (_vm.message.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    staticClass: "btn action wider ml-auto",
    attrs: {
      "type": "submit",
      "value": "Send"
    }
  })])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-32b3b394", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b3b394"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/AgentNewMessage.vue
// module id = 860
// module chunks = 0